const styles = {
  icon__color: {
    borderRadius: 0,
    height: '1.5em',
    width: '1.5em',
  },
};

export default styles;
